import { render, staticRenderFns } from "./car-tech2.vue?vue&type=template&id=59a112a4&"
import script from "./car-tech2.vue?vue&type=script&lang=js&"
export * from "./car-tech2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CarColor: require('/var/www/components/car/car-color.vue').default,CarConfiguration: require('/var/www/components/car/car-configuration.vue').default})
